export const personFeatures = ['sessions', 'exercises', 'documents'];
export const defaultOrgFeatures = {
  sessions: true,
  rehab: true,
  documents: true,
  persons: true,
  video: false,
  growthtracker: true,
  growthTracker_v2: false,
  users: true,
  testsets: true,
  personInvite: true,
  exercises: true,
  organisations: true,
  benchmarks: true,
  results: true,
  prevention: true
};

export const personRules = [
  {
    subject: 'Sessions',
    action: 'view'
  },
  {
    subject: 'SessionReport',
    action: 'downloadSessionReport'
  },
  {
    subject: 'SessionReport',
    action: 'mailSessionReport'
  },
  {
    subject: 'SessionReport',
    action: 'generateSkReport'
  },
  {
    subject: 'Programs',
    action: 'view'
  },
  {
    subject: 'PreventionReport',
    action: 'view'
  }
];

export const adminRules = [
  {
    subject: 'Sessions',
    action: 'download-group'
  },
  {
    subject: 'Sessions',
    action: 'download-individual'
  },
  {
    subject: 'SessionReport',
    action: 'downloadSessionReports'
  },
  {
    subject: 'SessionReport',
    action: 'mailSessionAllReportOfTestSession'
  },
  {
    subject: 'SessionReport',
    action: 'downloadSessionReport'
  },
  {
    subject: 'SessionReport',
    action: 'mailSessionReport'
  },
  {
    subject: 'SessionReport',
    action: 'generateSkReport'
  },
  {
    subject: 'SessionReport',
    action: 'downloadSkReports'
  },
  {
    subject: 'SessionReport',
    action: 'mailSkReport'
  },
  {
    subject: 'SessionReport',
    action: 'mailSkReports'
  },
  {
    subject: 'SessionReport',
    action: 'generateHanReport'
  },
  {
    subject: 'TestData',
    action: 'manage'
  },
  {
    subject: 'PreventionReport',
    action: 'view'
  }
];

export const reporterFeatures = ['sessions', 'persons'];

export const reporterRules = [
  {
    subject: 'Sessions',
    action: 'manage'
  },
  {
    subject: 'Sessions',
    action: 'download-group'
  },
  {
    subject: 'Sessions',
    action: 'export',
    inverted: true
  },
  {
    subject: 'Sessions',
    action: 'copy',
    inverted: true
  },
  {
    subject: 'Sessions',
    action: 'download-form',
    inverted: true
  },
  {
    subject: 'Sessions',
    action: 'download-individual'
  },
  {
    subject: 'SessionReport',
    action: 'downloadSessionReport',
    inverted: true
  },
  {
    subject: 'SessionReport',
    action: 'downloadSessionReports',
    inverted: true
  },
  {
    subject: 'SessionReport',
    action: 'mailSessionReport',
    inverted: true
  },
  {
    subject: 'SessionReport',
    action: 'downloadSkReports'
  },
  {
    subject: 'SessionReport',
    action: 'generateSkReport'
  },
  {
    subject: 'PreventionReport',
    action: 'view',
    inverted: true
  },
  {
    subject: 'Persons',
    action: 'manage'
  },
  {
    subject: 'Groups',
    action: 'manage'
  }
];

export const gsvRules = [
  {
    subject: 'GSV',
    action: 'manage'
  },
  {
    subject: 'Exercises',
    action: 'manage'
  },
  {
    subject: 'Collections',
    action: 'manage'
  },
  {
    subject: 'Trainings',
    action: 'manage'
  },
  {
    subject: 'Exercise',
    action: 'create'
  },
  {
    subject: 'Exercise',
    action: 'read'
  },
  {
    inverted: true,
    subject: 'Exercise',
    action: 'update',
    conditions: { editable: false }
  },
  {
    inverted: true,
    subject: 'Exercise',
    action: 'delete',
    conditions: { editable: false }
  },
  {
    subject: 'Template',
    action: 'create'
  },
  {
    subject: 'Template',
    action: 'read'
  },
  {
    subject: 'Template',
    action: 'update',
    conditions: { editable: true }
  },
  {
    subject: 'Template',
    action: 'delete',
    conditions: { editable: true }
  },
  {
    subject: 'Collection',
    action: 'create'
  },
  {
    subject: 'Collection',
    action: 'read'
  },
  {
    subject: 'Collection',
    action: 'update',
    conditions: { editable: true }
  },
  {
    subject: 'Collection',
    action: 'delete',
    conditions: { editable: true }
  },
  {
    subject: 'Training',
    action: 'create'
  },
  {
    subject: 'Training',
    action: 'read'
  },
  {
    subject: 'Training',
    action: 'update',
    conditions: { editable: true }
  },
  {
    subject: 'Training',
    action: 'delete',
    conditions: { editable: true }
  },
  {
    subject: 'Sessions',
    action: 'manage',
    inverted: true
  },
  {
    subject: 'Rehab',
    action: 'manage',
    inverted: true
  },
  {
    subject: 'Prevention',
    action: 'manage',
    inverted: true
  }
];

export const gsvPersonRules = [
  {
    subject: 'Settings',
    action: 'manage',
    inverted: true
  },
  {
    subject: 'Persons',
    action: 'manage',
    inverted: true
  },
  {
    subject: 'Users',
    action: 'manage',
    inverted: true
  }
];

export const VitaleRules = [
  {
    subject: 'Vitale',
    action: 'manage'
  },
  {
    subject: 'Session',
    action: 'manage',
    inverted: true
  },
  {
    subject: 'Persons',
    action: 'manage',
    inverted: true
  },
  {
    subject: 'Rehab',
    action: 'manage',
    inverted: true
  },
  {
    subject: 'Prevention',
    action: 'manage',
    inverted: true
  },
  {
    subject: 'Benchmark',
    action: 'manage',
    inverted: true
  }
];

export const VitalePersonRules = [
  {
    subject: 'Videos',
    action: 'manage'
  },
  {
    subject: 'Video',
    action: 'create'
  },

  {
    subject: 'Video',
    action: 'update',
    conditions: { editable: true, finished: false },
    reason: 'Video is already finished'
  },
  {
    subject: 'Video',
    action: 'delete',
    conditions: { editable: true, finished: false },
    reason: 'Video is already finished'
  },
  {
    subject: 'Lessons',
    action: 'manage'
  },
  {
    subject: 'Lesson',
    action: 'create'
  },
  {
    subject: 'Lesson',
    action: 'update',
    conditions: { editable: true }
  },
  {
    subject: 'Lesson',
    action: 'delete',
    conditions: { editable: true }
  }
];

export const VitaleSubAdminRules = [
  {
    subject: 'Videos',
    action: 'manage'
  },
  {
    subject: 'Lessons',
    action: 'manage',
    inverted: true
  },
  {
    subject: 'Users',
    action: 'manage',
    inverted: true
  },
  {
    subject: 'Settings',
    action: 'manage'
  },
  {
    subject: 'Persons',
    action: [
      'read',
      'create',
      'update',
      'delete',
      'archive',
      'import',
      'copymove',
      'invite'
    ]
  }
];

export const VitaleAdminRules = [
  {
    subject: 'Videos',
    action: 'manage',
    inverted: true
  },
  {
    subject: 'Lessons',
    action: 'manage',
    inverted: true
  },
  {
    subject: 'Video',
    action: 'create',
    inverted: true
  },
  {
    subject: 'Persons',
    action: [
      'read',
      'create',
      'update',
      'delete',
      'archive',
      'import',
      'copymove',
      'invite'
    ]
  },
  {
    subject: 'Organisation',
    action: 'manage'
  },
  {
    subject: 'Organisations',
    action: 'manage'
  },
  {
    subject: 'Groups',
    action: 'manage'
  },
  {
    subject: 'Settings',
    action: 'manage'
  },
  {
    subject: 'Users',
    action: 'manage'
  }
];
